<template>
    <div class="engagement-report" :class="{ 'engagement-report--improvements': isEmailHealthImprovementsEnabled }">
        <template v-if="!isEmailHealthImprovementsEnabled">
            <div class="engagement-title">
                Engagement Report
            </div>
            <div class="engagement-sub-title">
                Last 30 Days
            </div>
        </template>

        <div v-if="data_loading" class="engagement-loading">
            <div class="engagement-loading-inner">
                <ds-placeholder :rows="rows" />
            </div>
        </div>

        <ds-table-grid
            v-if="thereAreEngagementResults && isEmailHealthImprovementsEnabled && isEngagementReportSelectable"
            ref="engagementTable"
            v-model="selectedRows"
            :limit="limit"
            :data="engagement"
            selectable
            :selected-options="tableActions"
            :sort-ascending="sortAscending"
            :sort-field.sync="sortField"
            data-qa="engagement-report"
            class="engagement-table"
            @action="handleSelectedAction"
            @sort="sort"
        >
            <ds-table-grid-column
                label="Full Name"
                prop="fullName"
                width="180"
                sortable
            >
                <template v-slot="form">
                    <a :href="'/Contact/manageContact.jsp?view=edit&ID=' + String(form.contactId)" target="_blank">
                        <span>{{ checkNoName(form.fullName) }}</span>
                    </a>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="Email"
                prop="emailAddress"
                width="200"
                sortable
            />

            <ds-table-grid-column
                label="Contact ID"
                prop="contactId"
                width="100"
                sortable
            />

            <ds-table-grid-column
                label="Emails Sent"
                prop="numberOfEmailsSent"
                width="100"
                sortable
            />

            <ds-table-grid-column
                label="Days Since Last Engagement"
                prop="daysSinceLastEngagement"
                width="250"
                sortable
            >
                <template v-slot="form">
                    <span> {{ neverEngaged(form.daysSinceLastEngagement) }} </span>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="Last Email Sent"
                prop="mostRecentSend"
                width="250"
                sortable
            >
                <template v-slot="form">
                    <span> {{ dateFormatDate(form.mostRecentSend) }} </span>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="Last Open Date"
                prop="mostRecentOpen"
                width="250"
                sortable
            >
                <template v-slot="form">
                    <span> {{ dateFormatDate(form.mostRecentOpen) }} </span>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="Last Clicked Date"
                prop="mostRecentClick"
                width="250"
                sortable
            >
                <template v-slot="form">
                    <span> {{ dateFormatDate(form.mostRecentClick) }} </span>
                </template>
            </ds-table-grid-column>
        </ds-table-grid>

        <ds-table-grid
            v-else-if="thereAreEngagementResults && isEmailHealthImprovementsEnabled"
            :limit="limit"
            :data="engagement"
            :sort-ascending="sortAscending"
            :sort-field.sync="sortField"
            data-qa="engagement-report"
            class="engagement-table"
            @sort="sort"
        >
            <ds-table-grid-column
                label="Full Name"
                prop="fullName"
                width="180"
                sortable
            >
                <template v-slot="form">
                    <a :href="'/Contact/manageContact.jsp?view=edit&ID=' + String(form.contactId)" target="_blank">
                        <span>{{ checkNoName(form.fullName) }}</span>
                    </a>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="Email"
                prop="emailAddress"
                width="200"
                sortable
            />

            <ds-table-grid-column
                label="Contact ID"
                prop="contactId"
                width="100"
                sortable
            />

            <ds-table-grid-column
                label="Emails Sent"
                prop="numberOfEmailsSent"
                width="100"
                sortable
            />

            <ds-table-grid-column
                label="Days Since Last Engagement"
                prop="daysSinceLastEngagement"
                width="250"
                sortable
            >
                <template v-slot="form">
                    <span> {{ neverEngaged(form.daysSinceLastEngagement) }} </span>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="Last Email Sent"
                prop="mostRecentSend"
                width="250"
                sortable
            >
                <template v-slot="form">
                    <span> {{ dateFormatDate(form.mostRecentSend) }} </span>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="Last Open Date"
                prop="mostRecentOpen"
                width="250"
                sortable
            >
                <template v-slot="form">
                    <span> {{ dateFormatDate(form.mostRecentOpen) }} </span>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="Last Clicked Date"
                prop="mostRecentClick"
                width="250"
                sortable
            >
                <template v-slot="form">
                    <span> {{ dateFormatDate(form.mostRecentClick) }} </span>
                </template>
            </ds-table-grid-column>
        </ds-table-grid>

        <ds-table-grid
            v-else-if="thereAreEngagementResults"
            :limit="limit"
            :data="engagement"
            data-qa="engagement-report"
            class="engagement-table"
            :sort-ascending="sortAscending"
            :sort-field.sync="sortField"
            @sort="sort"
        >
            <ds-table-grid-column
                label="Full Name"
                prop="fullName"
                width="180"
            >
                <template v-slot="form">
                    <a :href="'/Contact/manageContact.jsp?view=edit&ID=' + String(form.contactId)" target="_blank">
                        <span>{{ checkNoName(form.fullName) }}</span>
                    </a>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="Email"
                prop="emailAddress"
                width="200"
            />

            <ds-table-grid-column
                label="Contact ID"
                prop="contactId"
                width="100"
            />

            <ds-table-grid-column
                label="Emails Sent"
                prop="numberOfEmailsSent"
                width="100"
            />

            <ds-table-grid-column
                label="Days Since Last Engagement"
                prop="daysSinceLastEngagement"
                width="250"
                sortable
            >
                <template v-slot="form">
                    <span> {{ neverEngaged(form.daysSinceLastEngagement) }} </span>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="Last Email Sent"
                prop="mostRecentSend"
                width="250"
            >
                <template v-slot="form">
                    <span> {{ dateFormatDate(form.mostRecentSend) }} </span>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="Last Open Date"
                prop="mostRecentOpen"
                width="250"
                sortable
            >
                <template v-slot="form">
                    <span> {{ dateFormatDate(form.mostRecentOpen) }} </span>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="Last Clicked Date"
                prop="mostRecentClick"
                width="250"
                sortable
            >
                <template v-slot="form">
                    <span> {{ dateFormatDate(form.mostRecentClick) }} </span>
                </template>
            </ds-table-grid-column>
        </ds-table-grid>

        <div v-if="!loading && !thereAreEngagementResults" class="empty-state-message">
            <ds-inline-alert leading-icon type="subtle">
                {{ getEmptyStateMessage }}
            </ds-inline-alert>
        </div>

        <footer v-if="thereAreEngagementResults" class="pagination-footer">
            <pagination-control
                :total-count="totalCount"
                :limit="limit"
                :offset="offset"
                @page="updatePage"
            />

            <div class="page-size">
                <ds-select-field
                    v-model="limit"
                    class="limit-select"
                    dense
                    bind-value-only
                    :options="pageSizes"
                />
                Per Page
            </div>
        </footer>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import PaginationControl from '../shared/PaginationControl';
import { PAGINATION_SIZE } from '@/utils/email.util';

const EMPTY_STATE_MESSAGE = 'No email engagement has been recorded for the current reporting period';
const UPDATE_OPT_STATUS_ACTION = 'updateOptStatus';
const UPDATE_OPT_STATUS_ACTION_TYPE = 'UpdateOptInOutStatus';
const UPDATE_OPT_STATUS_ERROR_MESSAGE = 'Unable to start Update Opt-In/Out Status action';
const NO_SELECTED_CONTACTS_MESSAGE = 'Please select at least one contact.';

export default {
    components: {
        PaginationControl,
    },

    props: {
        timezone: String,
        offset: {
            type: Number,
            default: 0,
        },
        stacked: Boolean,
        isEmailHealthImprovementsEnabled: {
            type: Boolean,
            default: false,
        },
        isEngagementReportSelectable: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {

            allEngagement: [],
            pages: 0,
            sortAscending: false,
            sortField: 'daysSinceLastEngagement',
            queryIDLookup: {},
            language: navigator.language || navigator.userLanguage,
            limit: PAGINATION_SIZE,
            totalCount: 0,
            rowSelection: null,
            OrderFields: {
                fullName: 'FULL_NAME',
                emailAddress: 'EMAIL_ADDRESS',
                contactId: 'CONTACT_ID',
                numberOfEmailsSent: 'NUMBER_OF_EMAILS_SENT',
                daysSinceLastEngagement: 'ENGAGEMENT_DAYS',
                mostRecentSend: 'MOST_RECENT_SEND',
                mostRecentOpen: 'MOST_RECENT_OPEN',
                mostRecentClick: 'MOST_RECENT_CLICK',
            },
            OrderDirection: {
                true: 'ASC',
                false: 'DESC',
            },
            numberOfEmailsSent: 0,
            loading: true,
            rows: [
                { height: '2rem', boxes: [1] },
                { height: '2rem', boxes: [1] },
                { height: '2rem', boxes: [1] },
            ],
            selectedRows: [],
            tableActions: [
                { label: 'Update Opt-In/Out Status', value: UPDATE_OPT_STATUS_ACTION },
                { label: 'Clear', value: 'clear' },
            ],
        };
    },

    created() {
        this.rowSelection = 'single';
        this.load();
    },
    watch: {
        offset() {
            this.loadEngagement();
        },

        limit() {
            this.loadEngagement();
        },
    },

    computed: {
        pageSizes() {
            if (!this.isEmailHealthImprovementsEnabled) {
                return [{ label: '25', value: 25 }];
            }

            return [
                { label: '25', value: 25 },
                { label: '50', value: 50 },
                { label: '100', value: 100 },
                { label: '250', value: 250 },
                { label: '500', value: 500 },
            ];
        },

        engagement() {
            return this.allEngagement;
        },

        tenantTimeZone() {
            return this.timezone;
        },

        thereAreEngagementResults() {
            return !this.loading && Boolean(this.allEngagement.length);
        },

        data_loading() {
            return this.loading;
        },

        getEmptyStateMessage() {
            return EMPTY_STATE_MESSAGE;
        },
    },

    methods: {

        async handleSelectedAction(action) {
            switch (action) {
                case UPDATE_OPT_STATUS_ACTION:
                    await this.startUpdateOptStatusAction();
                    break;
                case 'clear':
                    this.clearSelections();
                    break;
                default:
                    break;
            }
        },

        getSelectedContactIds() {
            const selectedContactIds = this.selectedRows
                .map((row) => {
                    // ds-table-grid emits selected row indexes.
                    const selectedRowIndex = Number(row);

                    if (!Number.isInteger(selectedRowIndex) || selectedRowIndex < 0) {
                        return null;
                    }

                    const selectedRow = this.allEngagement[selectedRowIndex];

                    return Number(selectedRow?.contactId);
                })
                .filter((contactId) => Number.isInteger(contactId) && contactId > 0);

            return Array.from(new Set(selectedContactIds));
        },

        async startUpdateOptStatusAction() {
            const selectedContactIds = this.getSelectedContactIds();

            if (!selectedContactIds.length) {
                this.$toast({ message: NO_SELECTED_CONTACTS_MESSAGE });

                return;
            }

            const infusion = window.Infusion;
            const getJsonUrl = infusion?.Url?.getJsonUrl;
            const getJson = infusion?.Ajax?.getJson;
            const actionUrl = typeof getJsonUrl === 'function'
                ? getJsonUrl('searchAction', 'actionMenuSelected')
                : null;

            try {
                if (!actionUrl || typeof getJson !== 'function') {
                    throw new Error('Legacy ajax helpers not available');
                }

                await new Promise((resolve, reject) => {
                    getJson({
                        url: actionUrl,
                        data: {
                            contactIds: selectedContactIds,
                            actionType: UPDATE_OPT_STATUS_ACTION_TYPE,
                        },
                        success: (data) => {
                            if (data?.url) {
                                window.location.assign(data.url);
                                resolve();

                                return;
                            }

                            reject(new Error('No redirect url provided'));
                        },
                        error: (xhr, status, err) => {
                            const errorMessage = typeof err === 'string'
                                ? err
                                : err?.message || status || xhr?.statusText || 'Unknown error';

                            reject(new Error(`Unable to invoke action menu endpoint: ${errorMessage}`));
                        },
                    });
                });
            } catch (e) {
                this.$error({ message: UPDATE_OPT_STATUS_ERROR_MESSAGE });
            }
        },

        clearSelections() {
            this.selectedRows = [];

            this.$nextTick(() => {
                const tableGrid = this.$refs.engagementTable;

                if (tableGrid && tableGrid.resetSelections) {
                    tableGrid.resetSelections();
                }
            });
        },

        dateFormatDate (date) {
            if (!date) {
                return '<no date>';
            }

            const formattedDate = moment.utc(date).tz(this.tenantTimeZone);

            formattedDate.locale(this.language);

            return moment(formattedDate).format('llll');
        },

        neverEngaged(engagementDays) {
            if (engagementDays < 0) {
                return 'Never engaged';
            }

            return engagementDays;
        },

        checkNoName(name) {
            if (!name) {
                return '<no name>';
            }

            return name;
        },

        updatePage({ offset }) {
            this.offset = offset;
        },

        sort(field) {
            this.sortField = field.field;
            this.sortAscending = field.ascending;
            this.loadEngagement();
        },

        async load() {
            this.loadEngagement();
        },

        async loadEngagement() {
            try {
                // TODO: StartTime, EndTime to come from UI components EO-4456
                this.loading = true;
                const key = ''.concat('SortDirection_',
                    String(this.OrderDirection[this.sortAscending]), '__',
                    'SortField_',
                    String(this.OrderFields[this.sortField]));

                const theQueryId = (key in this.queryIDLookup) ? this.queryIDLookup[key] : null;

                const params = {
                    pageIndex: Math.floor(this.offset / this.limit),
                    pageSize: this.limit,
                    startTime: null,
                    endTime: null,
                    queryId: theQueryId,
                    engagementOrderBy: this.OrderFields[this.sortField],
                    sortOrder: this.OrderDirection[this.sortAscending],
                };

                const engagementResponse = await axios.get('/app/reportcentral/getEngagement',
                    { params });

                this.allEngagement = engagementResponse.data.engagement;
                this.totalCount = engagementResponse.data.totalSize;
                this.loading = false;

                // Add the current queryID to the lookup so we can use it when we pull next page
                if (!(key in this.queryIDLookup)) {
                    this.queryIDLookup[key] = engagementResponse.data.queryId;
                }
            } catch (e) {
                this.allEngagement = [];
                this.totalCount = 0;
                this.loading = false;
                this.$error({ message: 'Unable to get engagement' });
            }
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

.empty-state-message {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.engagement-loading {
    width: 100%;
}

footer {
    padding-top: $spacing-100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: inset 0 1px 0 $color-gray-200;

    @media($small) {
        grid-template-columns: 100%;
        justify-content: center;
        text-align: center;
    }

    .page-size {
        display: grid;
        grid-template-columns: px-to-rem(80) auto;
        align-items: center;
        grid-gap: $spacing-100;

        @media($small) { display: none }
    }
}

</style>


<style lang="scss" rel="stylesheet/scss">
.engagement-title{
    display: flex;
    font-size: large;
    justify-content: center;
    width: 100%;
    height: $spacing-250;
}

.engagement-sub-title{
    display: flex;
    font-size: small;
    justify-content: center;
    width: 100%;
    height: $spacing-250;
}

// Feature-flagged layout changes for isEmailHealthImprovementsEnabled.
// Keep these grouped here so cleanup is straightforward when the flag is removed.
.engagement-report--improvements {
    height: 100%;
    min-width: 0;

    .engagement-loading {
        // Match the table gutter treatment while keeping loading responsive.
        margin-left: -$spacing-200;
        margin-right: -$spacing-200;
        width: calc(100% + #{$spacing-400});
        min-width: 0;
        box-sizing: border-box;
        overflow-x: auto;
    }

    .engagement-loading-inner {
        width: 100%;
        min-width: px-to-rem(1544);
    }

    .empty-state-message {
        margin-left: -$spacing-200;
        margin-right: -$spacing-200;
        width: calc(100% + #{$spacing-400});
        min-width: 0;
    }

    .engagement-table {
        --checkbox-padding: #{$spacing-100 $spacing-050};
        margin-left: -$spacing-200;
        margin-right: -$spacing-200;
        width: calc(100% + #{$spacing-400});
        height: 100%;
        display: flex;
        flex-direction: column;

        col[name="checkbox"] {
            width: px-to-rem(56);
        }

        th.column-checkbox,
        td.column-checkbox {
            width: px-to-rem(56);
            min-width: px-to-rem(56);
            max-width: px-to-rem(56);
            padding-left: $spacing-050;
            padding-right: $spacing-050;
            text-align: center;
        }

        th.column-checkbox + th,
        td.column-checkbox + td {
            padding-left: $spacing-050;
        }

        th.column-checkbox .checkbox-container,
        td.column-checkbox .checkbox-container {
            padding-left: 0;
            padding-right: 0;
        }

        th.column-checkbox .checkbox,
        td.column-checkbox .checkbox {
            width: 100%;
            justify-content: center;
        }

        th,
        td {
            vertical-align: middle;
        }

        th .cell,
        td .cell {
            white-space: nowrap;
        }

        td .cell {
            overflow: hidden;
            text-overflow: ellipsis;
        }

        td .cell a {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .table-wrapper {
            height: auto;
            min-height: calc(100vh - #{px-to-rem(260)});
            flex: 1 1 auto;
            overflow-x: auto;

            @media(max-width: 749px) {
                min-height: calc(100vh - #{px-to-rem(300)});
            }
        }
    }
}

.engagement-table {
    .table-wrapper {
        height: calc(100vh - #{px-to-rem(349)});
        width: 100%;
        overflow-y: auto;

        @media(max-width: 749px) {
            height: calc(100vh - #{px-to-rem(355)});
        }
    }

    thead {
        background: $color-white;
        z-index: 2;
        border-top: none;
        box-shadow: inset 0 -1px 0 $color-gray-200;
    }

}
</style>
